export const FA_STATUS = {
  PENDING: {
    status_code: 'waiting',
    description: 'รอการอนุมัติ',
    color: 'warning',
  },
  APPROVED: {
    status_code: 'approved',
    description: 'อนุมัติ',
    color: 'success',
  },
  PARTIAL: {
    status_code: 'partial',
    description: 'อนุมัติบางส่วน',
    color: 'info',
  },
  REJECTED: {
    status_code: 'rejected',
    description: 'ไม่อนุมัติ',
    color: 'error',
  },
  CANCELLED: {
    status_code: 'cancelled',
    description: 'ยกเลิก',
    color: 'default',
  },
};
export default FA_STATUS;
